// custom typefaces
import "@fontsource-variable/montserrat";
import "@fontsource/merriweather";
// normalize CSS across browsers
import "./src/normalize.css";
// custom CSS styles
import "./src/style.css";
import "./src/saas.css";

// Highlighting for code blocks
import "prismjs/themes/prism.css";

// Tailwind
import "./src/global.css";

import React from "react";
import CookieNotice from "./src/components/CookieNotice";
import { loadSmartlook, getRecordingConsent } from "./src/utils/tracking";
import { recordRouteUpdate } from "./src/utils/navigationHistory";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieNotice />
  </>
);

export const onClientEntry = () => {
  // Google Ads tag is loaded by gatsby-plugin-google-gtag (see gatsby-config.js).
  // Consent defaults are set via the inline script in gatsby-ssr.js.

  // Smartlook loads only with explicit recording consent (CIPA opt-in).
  if (getRecordingConsent() === "accepted") {
    loadSmartlook();
  }
};

// Same-pathname navigations that only change query params — e.g. RegionMap
// stamping "?region=&contractors=1" onto the current URL so Back from a
// contractor profile can restore the open list — shouldn't trigger Gatsby's
// page-change scroll reset. That reset fought our own smooth scrollIntoView
// there, showing up as a jump/mini-reload right as the list was fading in.
// Leaving scroll alone here (returning false) hands it entirely back to our
// own handler for those transitions; real page-to-page navigations still get
// Gatsby's normal scroll behavior.
export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  const prevPath = prevRouterProps?.location?.pathname;
  const nextPath = routerProps?.location?.pathname;
  if (prevPath && nextPath && prevPath === nextPath) {
    return false;
  }
  return true;
};

// Fires on every route change, including the initial page load — see
// navigationHistory.ts for how that first call is distinguished from a real
// in-app navigation.
export const onRouteUpdate = () => {
  recordRouteUpdate();
};

// export const onRouteUpdate = loc => {
//   const { state } = loc.location;

//   if (state && state.refocusId) {
//     const elem = document.getElementById(state.refocusId);

//     if (elem) {
//       elem.focus();
//     }
//   }
// };
